<app-breadcrumb></app-breadcrumb>

<div class="card mb-0">
    <div class="card-body">
        <div class="row">
            <div class="col-auto">
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control" placeholder="검색어"
                        [(ngModel)]="searchValue"
                        (keyup.enter)="keyupEnterSearchValue($event)">
                    <div class="input-group-append">
                        <button type="button" class="btn btn-outline-secondary"
                            (click)="clickSearch()">
                            <i class="fas fa-search"></i>
                            <span class="ml-1">
                                검색
                            </span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-auto">
                <select class="form-control form-control-sm"
                    [(ngModel)]="selectedYear"
                    (ngModelChange)="changeYear($event)">
                    <option *ngFor="let item of listYear;" [ngValue]="item">{{item}} 년</option>
                </select>
            </div>
            <div class="col-auto">
                <select class="form-control form-control-sm"
                    [(ngModel)]="selectedMonth"
                    (ngModelChange)="changeMonth($event)">
                    <option *ngFor="let item of listMonth;" [ngValue]="item">{{item}} 월</option>
                </select>
            </div>
            <div class="col"></div>
            <div class="col-auto">
                <button type="button" class="btn btn-sm btn-outline-success"
                    (click)="excelDownload()">
                    <i class="fas fa-file-excel"></i>
                    <span class="ml-1">엑셀출력</span>
                </button>
            </div>
        </div>

        <div class="table-responsive mt-3">
            <table class="table table-sm table-hover align-items-center mb-0">
                <thead>
                    <tr class="text-center">
                        <th>
                            차량번호
                        </th>
                        <th>
                            운전자
                        </th>
                        <th>
                            운행시간
                        </th>
                        <th>
                            운행거리(km)
                        </th>
                        <th>
                            과속
                        </th>
                        <th>
                            장기과속
                        </th>
                        <th>
                            급가속
                        </th>
                        <th>
                            급출발
                        </th>
                        <th>
                            급감속
                        </th>
                        <th>
                            급정지
                        </th>
                        <th>
                            급진로변경
                        </th>
                        <th>
                            급앞지르기
                        </th>
                        <th>
                            급좌우회전
                        </th>
                        <th>
                            급U턴
                        </th>
                        <th>
                            공회전
                        </th>
                        <th>
                            공회전+고RPM
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of listItem;let idx = index;" class="text-center"
                        [class.table-secondary]="selectedRow === idx"
                        (click)="selectRow(idx)">
                        <td>
                            <button type="button" class="btn btn-sm btn-link text-cyan">
                                {{item.dtgCarNo}}
                            </button>
                        </td>
                        <td>
                            {{item.userId}}
                        </td>
                        <td>
                            {{item.dtgRegDtDuration | filterSecToTime}}
                        </td>
                        <td>
                            {{item.dtgDistAccumul | filterDist | number:'0.0-3'}}
                        </td>
                        <td>
                            {{item.cntRule1 | number}}
                        </td>
                        <td>
                            {{item.cntRule2 | number}}
                        </td>
                        <td>
                            {{item.cntRule3 | number}}
                        </td>
                        <td>
                            {{item.cntRule4 | number}}
                        </td>
                        <td>
                            {{item.cntRule5 | number}}
                        </td>
                        <td>
                            {{item.cntRule6 | number}}
                        </td>
                        <td>
                            {{item.cntRule7 | number}}
                        </td>
                        <td>
                            {{item.cntRule8 | number}}
                        </td>
                        <td>
                            {{item.cntRule9 | number}}
                        </td>
                        <td>
                            {{item.cntRule10 | number}}
                        </td>
                        <td>
                            {{item.durRule101 | filterSecToTime}}
                        </td>
                        <td>
                            {{item.durRule102 | filterSecToTime}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="mt-3">
            <list-paging
                [inputPagingInfo]="pagingInfo"
                (callbackClickPageNumber)="callbackClickPageNumber($event)"
                (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
        </div>
    </div>
</div>

<div class="card-deck mt-3">
    <div class="card mb-0">
        <div class="card-header bg-white">
            <div class="h5 font-weight-normal mb-0">
                경제운전 불이행 건수
            </div>
        </div>
        <div class="card-body p-2">
            <div class="w-100">
                <div id="chart-01" style="height: 200px;">chart01</div>
            </div>
        </div>
    </div>
</div>